import { NAVIGATION_PANEL_CLASSES } from 'www/vue_components/common/PopupMap/constants'

function getPinTemplate({
  text,
  classes = '',
  isOnMap,
}) {
  const pinOnMapClass = isOnMap ? ` ${NAVIGATION_PANEL_CLASSES.pinOnMap}` : ''

  return `
        <div
            class="${NAVIGATION_PANEL_CLASSES.pin}${pinOnMapClass} ${classes}"
        >
            <div class="bg-gray-0--text">${text}</div>
        </div>
    `
}

export default getPinTemplate
